import { Outlet, useParams } from 'react-router'
import { ACCOUNT_PERMISSION } from '../../shared/constants'
import { useHasAccountPermission } from '../account-permissions'
import { useLayoutsByIdentifier, useLayoutRemove } from '../api/layouts'
import { Button, ButtonLink } from '../components/button'
import { Paper } from '../components/paper'

export function ObjectLayouts({ kind }: { kind?: string }) {
	const { object = kind } = useParams<{ object: string }>()
	if (!object) throw new Error('Invalid invocation')

	const query = useLayoutsByIdentifier({ object })
	const remove = useLayoutRemove()
	const canEditLayouts = useHasAccountPermission(ACCOUNT_PERMISSION.EDIT_LAYOUTS)
	const canDeleteLayouts = useHasAccountPermission(ACCOUNT_PERMISSION.DELETE_LAYOUTS)

	const onRemove = (id: string) => {
		if (confirm('Opravdu chcete smazat rozložení?')) {
			remove.mutate(id)
		}
	}

	return (
		<Paper>
			<div className="flex justify-between gap-4 px-5 py-4 sm:px-6 sm:py-5">
				<h3 className="text-md font-bold">Seznam rozložení</h3>
			</div>
			<div className="overflow-x-auto">
				<table className="w-full">
					<thead>
						<tr className="border-b border-slate-200">
							<th className="px-5 py-3 text-left text-xs font-medium text-slate-500 uppercase">
								ID
							</th>
							<th className="px-5 py-3 text-left text-xs font-medium text-slate-500 uppercase">
								Typ
							</th>
							<th className="px-5 py-3 text-left text-xs font-medium text-slate-500 uppercase">
								Název
							</th>
							<th className="px-5 py-3"></th>
						</tr>
					</thead>
					<tbody>
						{query.data?.map(layout => (
							<tr key={layout.id} className="border-b border-slate-100">
								<td className="px-5 py-4 text-sm">{layout.id}</td>
								<td className="px-5 py-4 text-sm">{layout.type}</td>
								<td className="px-5 py-4 text-sm">{layout.name}</td>
								<td className="px-5 py-4 text-sm space-x-2">
									<ButtonLink
										isDisabled={!canEditLayouts}
										variant="SECONDARY"
										size="SMALL"
										to={`edit/${layout.id}`}
									>
										Upravit
									</ButtonLink>
									<Button
										isDisabled={!canDeleteLayouts}
										variant="DANGER"
										size="SMALL"
										onPress={() => onRemove(layout.id)}
									>
										Smazat
									</Button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<Outlet />
		</Paper>
	)
}
